import React from "react";
import {
  BookOpen,
  Users,
  TrendingUp,
  Sprout,
  Database,
  Infinity as InfinityIcon,
} from "lucide-react";

const OUTCOMES = [
  { icon: BookOpen, label: "Tell the story of Country" },
  { icon: Users, label: "Support Indigenous-led planning" },
  { icon: TrendingUp, label: "Strengthen funding applications" },
  { icon: Sprout, label: "Guide restoration activities" },
  { icon: Database, label: "Build local knowledge systems" },
  {
    icon: InfinityIcon,
    label: "Create lasting resources for future generations",
  },
];

export default function ExampleOutcomes() {
  return (
    <section
      id="outcomes"
      data-testid="section-outcomes"
      className="relative py-24 md:py-32 bg-[#F3EFEA]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-end mb-14">
          <div className="lg:col-span-7">
            <div className="bm-eyebrow mb-6">Section 11 — Outcomes</div>
            <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#2D2621]">
              Example Outcomes
            </h2>
          </div>
          <div className="lg:col-span-5 lg:text-right">
            <p className="text-[#584D45] text-lg leading-relaxed">
              A Bush Mapping project can help communities:
            </p>
          </div>
        </div>

        <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {OUTCOMES.map(({ icon: Icon, label }, i) => (
            <li
              key={label}
              className="bm-card p-7 md:p-8 flex flex-col"
            >
              <div className="flex items-center justify-between mb-6">
                <span className="w-12 h-12 rounded-full border border-[#C5B6A3] text-[#A95A3F] flex items-center justify-center">
                  <Icon size={20} />
                </span>
                <span className="font-serif-display text-2xl text-[#C5B6A3]">
                  / {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <p className="font-serif-display text-xl md:text-2xl text-[#2D2621] leading-snug">
                {label}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
